module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-3.92c2ea7d.jpeg";